export const FETCH_BALANCES_INITIATED = 'FETCH_BALANCES_INITIATED';
export const FETCH_BALANCES_SUCCEEDED = 'FETCH_BALANCES_SUCCEEDED';
export const FETCH_BALANCES_FAILED = 'FETCH_BALANCES_FAILED';
